import { initDailyMessages } from './handlers.js';
import { initTagAutocomplete } from './tag-autocomplete.js';

export function initAssignDailyMessage() {
	initDailyMessages();
	initTagAutocomplete();
}
